import { UI } from '../nextpage';
import { NavBuilder } from './nav_builder';
import { NavTypes } from '../utilities/enums';

export class NavMenu {
    constructor(private NP: UI, private NBC: NavBuilder) {
        // Navigation and Menu components
        // Event registration
        this.NP.registerEvent("topMenuClick", (e: Event) => {
            e.stopImmediatePropagation();
        });
        this.NP.registerEvent("topMenuToggleClick", (e: Event) => {
            e.stopImmediatePropagation();
            const menuToggle = document.getElementById('toggle-menu') as HTMLDivElement;
            const topMenu = document.getElementById('top-menu') as HTMLDivElement;
            const menuOpen = menuToggle.classList.contains('aria-pressed');
    
            this.NP.blurPromise(e.target as Element).then(() => {
                if (!menuOpen) {
                    document.body.classList.toggle('menu-open', true);
                    this.NP.toggleAriaState(menuToggle, "pressed", true);
                    this.NP.toggleAriaState(topMenu, "expanded", true);
                    this.NP.properties.blurAria.push(
                        {selector: menuToggle, class: 'pressed', active: false},
                        {selector: topMenu, class: 'expanded', active: false}
                    );
                    this.NP.properties.blurClasses.push(
                        {selector: document.body, class: 'menu-open', active: false}
                    );
                }
                if (!this.NP.properties.isMobile && !this.NP.properties.isTablet) {
                    this.NP.layout.checkNavContainerHeight(this.NP.properties);
                    return;
                }
                const navContainer = document.getElementById('nav-container');
                if (navContainer === undefined) {
                    this.NP.layout.checkNavContainerHeight(this.NP.properties);
                    return;
                }
                const activeNavs = navContainer.querySelectorAll('nav.active');
                if (activeNavs.length > 0) {
                    activeNavs.forEach((an) => {
                        this.NP.toggleAriaState(an, 'hidden', menuOpen);
                    });
                } else {
                    const mainNav = navContainer.querySelector('nav.mainnav');
                    this.NP.toggleAriaState(mainNav, 'hidden', menuOpen);
                }
                this.NP.layout.checkNavContainerHeight(this.NP.properties);
            }).catch(rejection => console.log(`topMenuToggleClick event broken promise: ${rejection}`));
        });
        this.NP.registerEvent("topMenuSubnavLinkClick", (e: Event) => {
            e.stopImmediatePropagation();
            const clicked = e.target as HTMLElement;
            const dataNav = clicked.dataset.subnav;
            if (dataNav === undefined || dataNav === "") {
                return;
            }
            const subNavs = document.querySelectorAll("#top-menu .subnav");
            let linkedNav: HTMLElement = null;
            [].forEach.call(subNavs, (subNav: HTMLElement) => {
                if (subNav.dataset.navParent === dataNav) {
                    linkedNav = subNav;
                }
            });
            if (linkedNav === null) {
                return;
            }
            const navHeight = linkedNav.offsetHeight + "px";
            const navContainer = document.querySelector("#nav-container") as HTMLElement;
            if (navContainer === null) {
                return;
            }
            navContainer.classList.toggle("subnav-active", true);
            navContainer.style.height = navHeight;
            linkedNav.classList.toggle("active", true);
            this.NP.toggleAriaState(linkedNav, "hidden", false);

            [].forEach.call(linkedNav.parentElement.children, (navSib: HTMLElement) => {
                if (navSib.nodeName !== "NAV") {
                    return;
                }
                if (navSib === linkedNav) {
                    this.NP.toggleAriaState(navSib, "hidden", false);
                    return;
                }
                this.NP.toggleAriaState(navSib, "hidden", true);
            });
        });
        this.NP.registerEvent("topMenuPreviousLinkClick", (e: Event) => {
            e.stopImmediatePropagation();
            const clicked = e.target as HTMLElement;
            const navContainer = document.querySelector("#nav-container") as HTMLElement;
            const navParent = clicked.parentElement.parentElement;
            let containerToggle = true;
            let navHeight;
            let prevNav: HTMLElement = null;
            let foundPrev = false;
            [].forEach.call(navParent.parentElement.children, (pNav: HTMLElement) => {
                if (foundPrev === true) {
                    return;
                }
                if (pNav === navParent) {
                    foundPrev = true;
                    return;
                }
                if (!pNav.classList.contains("subnav")) {
                    return;
                }
                if (!pNav.classList.contains("active")) {
                    return;
                }
                prevNav = pNav;
            });

            navParent.classList.toggle("active", false);
            this.NP.toggleAriaState(navParent, "hidden", true);
            if (prevNav === null) {
                containerToggle = false;
                const mainnav = navContainer.querySelector(".mainnav");
                if (mainnav !== null) {
                    this.NP.toggleAriaState(mainnav, "hidden", false);
                    navHeight = mainnav.clientHeight + "px";
                }
            } else {
                this.NP.toggleAriaState(prevNav, "hidden", false);
                navHeight = prevNav.clientHeight + "px";
            }
            navContainer.classList.toggle("subnav-active", containerToggle);
            navContainer.style.height = navHeight;
        });
        this.NP.registerEvent("detailPageNavigationToggleClick", (e: Event) => {
            const clicked = e.target as HTMLElement;
            const navParent = clicked.parentElement;
            const navState = !navParent.classList.contains("aria-expanded");

            this.NP.toggleAriaState(navParent, "expanded", navState);
        });
        this.NP.registerEvent("detailPageNavigationLinkClick", (e: Event) => {
            const clicked = e.target as HTMLElement;
            const linkHref = clicked.getAttribute("href");
            if (linkHref.indexOf("#") === -1) {
                return;
            }

            const leftNav = document.querySelector("#left-nav");
            const baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            const baseUrlLength = baseUrl.length;
            if (linkHref.substring(0, baseUrlLength) !== baseUrl) {
                return;
            }
            let correspondingLeftNavLink: HTMLElement = null;
            leftNav.querySelectorAll("a").forEach((link) => {
                if (link.getAttribute("href") !== linkHref) {
                    return;
                }
                correspondingLeftNavLink = link;
            });
            if (correspondingLeftNavLink === null) {
                return;
            }

            leftNav.querySelectorAll("li, a").forEach((els) => {
                this.NP.toggleAriaState(els, "selected", false);
                if (els.nodeName !== "LI" || !els.classList.contains("children")) {
                    return;
                }
                this.NP.toggleAriaState(els, "expanded", false);
            });

            this.NP.toggleAriaState(correspondingLeftNavLink.parentElement, "selected", true);

            let correspondingParent = correspondingLeftNavLink.parentElement;
            while(correspondingParent !== null) {
                if (correspondingParent.id === "left-nav") {
                    correspondingParent = null;
                    continue;
                }
                if (correspondingParent.nodeName !== "LI" || !correspondingParent.classList.contains("children")) {
                    correspondingParent = correspondingParent.parentElement;
                    continue;
                }
                this.NP.toggleAriaState(correspondingParent, "expanded", true);
            }
        });
        this.NP.components.globalTopMenu = (): void => {
            const topMenu = document.querySelector("#top-menu") as HTMLElement;
            const toggleMenu = document.querySelector("#toggle-menu") as HTMLElement;

            if (topMenu !== null) {
                topMenu.addEventListener("click", (ev: Event) => this.NP.events.topMenuClick(ev));
            }
            if (toggleMenu !== null) {
                toggleMenu.addEventListener("click", (ev: Event) => this.NP.events.topMenuToggleClick(ev));
            }

            const mainnav = document.querySelector("#nav-container nav.mainnav");
            if (mainnav === null) {
                this.NBC.buildNavigation(NavTypes.TOPMENU);
            } else {
                this.NP.mapAriaState(mainnav, "hidden");
            }

            const subnavs = document.querySelectorAll("#nav-container [data-subnav]");
            const previousLinks = document.querySelectorAll("#nav-container li.previous");
            if (subnavs.length > 0) {
                subnavs.forEach((subnav) => {
                    this.NP.mapAriaState(subnav, "hidden");
                    subnav.addEventListener("click", (ev: Event) => this.NP.events.topMenuSubnavLinkClick(ev));
                });
            }
            if (previousLinks.length > 0) {
                previousLinks.forEach((prevLink) => {
                    prevLink.addEventListener("click", (ev: Event) => this.NP.events.topMenuPreviousLinkClick(ev));
                });
            }
        };
        this.NP.components.globalSiteSpecificNavigation = (): void => {
            const siteSpecificNav = document.querySelectorAll("#site-specific-nav li");
            if (siteSpecificNav.length === 0) {
                this.NBC.buildNavigation(NavTypes.SITESPECIFIC);

                const mains = document.querySelectorAll('main.container');
                if (mains.length != 0) {
                    this.NP.components.layoutMorphs();
                }
            }
        };
        this.NP.components.detailPageNavigation = (): void => {
            const leftNav = document.querySelector("#left-nav");
            if (leftNav === null) {
                return;
            }
            const leftNavItems = leftNav.querySelectorAll("li");
            if (leftNavItems.length === 0) {
                this.NBC.buildNavigation(NavTypes.DETAIL);
            }
            leftNavItems.forEach((n) => { this.NP.mapAriaState(n, "selected"); });

            const currentLeftNav = this.findCurrentPageInNavigation(leftNav);
            if (currentLeftNav !== null) {
                this.NP.toggleAriaState(currentLeftNav, "selected", true);

                let correspondingParent = currentLeftNav.parentElement;
                while(correspondingParent !== null) {
                    if (correspondingParent.id === "left-nav") {
                        correspondingParent = null;
                        continue;
                    }
                    if (correspondingParent.nodeName !== "LI" || !correspondingParent.classList.contains("children")) {
                        correspondingParent = correspondingParent.parentElement;
                        continue;
                    }
                    this.NP.toggleAriaState(correspondingParent, "expanded", true);
                }
            }

            const navToggles = leftNav.querySelectorAll(".nav-toggle");
            const navLinks = document.querySelectorAll("nav a");

            if (navToggles !== null && navToggles.length > 0) {
                navToggles.forEach((nav) => {
                    nav.addEventListener("click", (ev: Event) => this.NP.events.detailPageNavigationToggleClick(ev));
                });
            }
            if (navLinks !== null && navLinks.length > 0) {
                navLinks.forEach((nav) => {
                    nav.addEventListener("click", (ev: Event) => this.NP.events.detailPageNavigationLinkClick(ev));
                });
            }
        };
    }

    findCurrentPageInNavigation(nav: Element): Element {
        if (nav === undefined || nav === null) {
            return null;
        }
        const currentNav = nav.querySelectorAll("li.aria-selected");
        // If a list element has already been marked as selected no need to continue
        if (currentNav.length > 0) {
            return currentNav[currentNav.length - 1];
        }
        const baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        const baseUrlLength = baseUrl.length;
        const baseUrlMatches: Array<HTMLAnchorElement> = [];
        // Start by finding all anchors in the left navigation whose href matches the baseUrl
        [].forEach.call(nav.querySelectorAll("a"), (navAnchor: HTMLAnchorElement) => {
            const link = navAnchor.getAttribute("href");
            if (link === undefined || link === null || link === "") {
                return;
            }
            const linkPart = link.substring(0, baseUrlLength);
            if (linkPart !== baseUrl) {
                return;
            }
            baseUrlMatches[baseUrlMatches.length] = navAnchor;
        });
        // If no matches are found return null
        if (baseUrlMatches.length === 0) {
            return null;
        }
        // If exactly 1 match is found return that match
        if (baseUrlMatches.length === 1) {
            return baseUrlMatches[0];
        }

        const fullUrl = baseUrl + window.location.search + window.location.hash;
        const urlWithHash = baseUrl + window.location.hash;
        const urlWithSearch = baseUrl + window.location.search;
        // First try to match baseUrl + search + hash
        const searchHashMatch = baseUrlMatches.find(function(anchor: HTMLAnchorElement){
            return anchor.getAttribute("href") === fullUrl;
        });
        if (searchHashMatch !== undefined) {
            return searchHashMatch;
        }
        // If not found try to match baseUrl + hash
        const hashMatch = baseUrlMatches.find(function(anchor: HTMLAnchorElement){
            return anchor.getAttribute("href") === urlWithHash;
        });
        if (hashMatch !== undefined) {
            return hashMatch;
        }
        // If not found try to match baseUrl + search
        const searchMatch = baseUrlMatches.find(function(anchor: HTMLAnchorElement){
            return anchor.getAttribute("href") === urlWithSearch;
        });
        return searchMatch !== undefined ? searchMatch : null;
    }
}